import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const ProcurementService = {
    async getAllProcurements(filters = {}) {
        try {
            const result = await axios.get(`${apiUrl}/Partner/Procurement`, { params: filters });
            if (result) {
                return result.data;
            }
        } catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
        return {
            status: 0,
            message: "Erreur de chargement des achats",
            data: [],
        };
    },

    async getProcurementDetails(market) {
        const params = typeof market === "object"
            ? {
                execution_marche_id: market?.execution_marche_id || undefined,
                id_marche_spm: market?.id_marche_spm || undefined,
            }
            : { execution_marche_id: market };
        try {
            const result = await axios.get(`${apiUrl}/Partner/Procurement/detail`, {
                params,
            });
            if (result) {
                return result.data;
            }
        } catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
        return {
            status: 0,
            message: "Erreur de chargement du detail du marche",
            data: null,
        };
    },
};

export default ProcurementService;
